import renderComponent from 'recompose/renderComponent';
import compose from 'recompose/compose';
import { withRouter } from 'next/router';

import branch from '@aveneo/frontmoon-utils/lib/hocs/branch';

import RestaurantMenu from './RestaurantMenu';
import connectContainer from './RestaurantMenuContainer';
import ErrorPage from '../ErrorPage';

export default compose(
    connectContainer,
    withRouter,
    branch(
        ({ isLoaded }) => !isLoaded,
        renderComponent(ErrorPage)
    )
)(RestaurantMenu);
